import { Platform, Pressable } from "react-native";

import { ColorType, useTheme } from "./AHTheme/AHTheme";
import { useLayoutContext } from "./LayoutProvider";
import { useTransition } from "react";

import { useDialogButtonHeight } from "./useDialogButtonHeight";
import { AHText } from "./Text/AHText";

export function BaseButton(props: {
  children: React.ReactNode;
  background?: ColorType;
  borderColor?: ColorType;
  disabled?: boolean;
  onPress?: () => void;
  indicatorSize?: number; // used for padding purposes
}) {
  const layout = useLayoutContext();

  const [isPending, startTransition] = useTransition();

  const height = useDialogButtonHeight();
  const onPress = () =>
    startTransition(() => {
      props.onPress?.();
    });

  const paddingHorizontal = layout.space.small;

  const paddingLeft = props.indicatorSize
    ? (height - props.indicatorSize) / 2
    : paddingHorizontal;

  const borderColor = useTheme()[props.borderColor || "border-primary"];
  const backgroundColor = useTheme()[props.background || "background"];
  return (
    <Pressable
      style={(state) => [
        {
          flexDirection: "row",
          height,
          opacity: state.pressed || isPending ? 0.5 : 1,
          transition:
            Platform.OS === "web" ? "transform 0.1s ease-in-out" : undefined,
          alignItems: "center",
          borderRadius: layout.radius.full,
          borderColor,
          borderWidth: 1,
          backgroundColor,
          flexGrow: 0,
          flexShrink: 1,
          ...(Platform.OS === "web"
            ? { cornerShape: "superellipse(1.15)" }
            : {}),
          borderCurve: "continuous",

          overflow: "hidden",
          paddingHorizontal: paddingHorizontal,
          paddingLeft: paddingLeft,
          gap: layout.space.small,
        },
      ]}
      onPress={onPress}
      disabled={props.disabled}
    >
      {props.children}
    </Pressable>
  );
}

BaseButton.Label = ButtonLabel;

function ButtonLabel(props: { children: React.ReactNode; color?: ColorType }) {
  const color = props.color || "text-primary";
  return (
    <AHText
      type="detail"
      color={color}
      selectable={false}
      numberOfLines={1}
      style={{ flexShrink: 1, flexGrow: 0 }}
    >
      {props.children}
    </AHText>
  );
}
